import React from "react";
import dayjs from "dayjs";
import PDFIcon from "../../resources/pdf_with_text.png";
import { ReactComponent as Calendar } from "../../resources/icons/calendar.svg";
import { ReactComponent as User } from "../../resources/icons/user.svg";

interface DocumentShowProps {
  title: string;
  docs: {
    id: number | string;
    name: string;
    size: number;
    uploader: {
      id: number;
      name: string;
    };
    uploadedAt: string;
  }[];
  onPreview?: (id: string | number, name: string) => void;
  rowItems?: {
    xl: number;
    lg: number;
    xs: number;
  };
}

const DocumentShow: React.FC<DocumentShowProps> = ({
  title,
  docs,
  onPreview,
  rowItems = { xl: 3, lg: 2, xs: 1 },
}) => {
  return (
    <div className="mb-6 bg-[#F9FAFB] p-4 rounded-lg">
      <h3 className="font-semibold mb-2">{title}</h3>
      <div
        className={`grid xl:grid-cols-${rowItems.xl} lg:grid-cols-${rowItems.lg} grid-cols-${rowItems.xs} gap-4`}
      >
        {docs.length > 0 ? (
          docs.map((doc) => (
            <div
              key={doc.id}
              className="flex items-center bg-white border border-[#D0D5DD] rounded-lg px-4 py-2 cursor-pointer"
              onClick={() => onPreview?.(doc.id, doc.name)}
            >
              <div className="relative w-[42px] mr-2 flex-shrink-0">
                <img
                  src={PDFIcon}
                  alt="PDF"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 flex flex-col overflow-hidden">
                <p className="font-medium truncate max-w-[80%]">
                  {decodeURIComponent(doc.name)}
                </p>
                <p className="text-xs text-gray-500">
                  {(doc.size / 1024).toFixed(1)} KB
                </p>
                <div className="mt-1 flex items-center space-x-3 text-xs text-gray-500">
                  <div className="flex items-center space-x-1">
                    <Calendar className="w-4 h-4" />
                    <span>{dayjs(doc.uploadedAt).format("DD.MM.YYYY")}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <User className="w-4 h-4" />
                    <span>{doc.uploader.name}</span>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-500">No documents yet</p>
        )}
      </div>
    </div>
  );
};

export default DocumentShow;
